import { render, staticRenderFns } from "./copyReturn.vue?vue&type=template&id=bc004448"
import script from "./copyReturn.vue?vue&type=script&lang=js"
export * from "./copyReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports